import portsApi from '../framework/ports/portsApi';

const FullScreenFrontend = {
  toggleFullScreen: () => portsApi.invoke('FullScreen.toggleFullScreen'),
  onFullScreenChange: (callback: Function) =>
    portsApi.on('FullScreen.onFullScreenChange', callback),
  isFullScreen: () => portsApi.invoke('FullScreen.isFullScreen'),
};

export default FullScreenFrontend;
